module.exports = __webpack_public_path__ + "img/shop_banner.07cb8908.jpg";